import types from "../actionTypes";
import setLoaderAction from "./loaderAction";
import { isSessionValid } from "./profileAction";
import * as toastAction from "../actions/toastAction";
import * as apiServices from "../../services/apiServices";
import apiConfig, {
    DEFAULT_ERROR_MESSAGE,
    ERROR_TIMEOUT,
} from "../../App.config";


/************************************ ACTIONS ****************************************/

function setMyApplications(myApplications) {
    return {
        type: types.SET_MY_APPLICATIONS,
        myApplications,
    };
}

function setMyApplicationsTotalCount(totalCount) {
    return {
        type: types.SET_MY_APPLICATIONS_TOTALCOUNT,
        totalCount,
    };
}


/************************************ ACTION CREATORS ****************************************/


export const getMyApplications = (payload, pagination,companyId) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .getMyApplications(payload,pagination,companyId)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                dispatch(setMyApplications(data.response));
                dispatch(setMyApplicationsTotalCount(data.totalCount))
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

export const downloadApplicationExcel = (startDate, endDate, profileReducer) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .downloadApplicationReport(startDate, endDate, profileReducer)
        .then(({ data }) => {
            if (dispatch(isSessionValid(data.errorMessage))) {
                return;
            }
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                if(data.fileBase64Data)
                    window.open("data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + data.fileBase64Data)
                else{
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};

